function Footer() {
  return (
    <footer className="bg-gray-800 text-white py-4 text-center">
      <p>© 2025 My Portfolio. All rights reserved.</p>
      <div className="flex justify-center space-x-4 mt-2">
        <a href="https://github.com/AlexandruDobos" className="hover:text-gray-400">GitHub</a>
        <a href="https://www.linkedin.com/in/alexdobosh/" className="hover:text-gray-400">LinkedIn</a>
        <a href="mailto:dobosalexandru2502@gmail.com" className="hover:text-gray-400">Email</a>
      </div>
    </footer>
  );
}

export default Footer;
